<template><div v-show="active" class="popover">
	<slot></slot>
</div></template>

<script>

import { createPopper } from '@popperjs/core';

let popovers = {};

export default {
	props: {
		name: {
			type: String,
			required: true
		},
		click: Boolean
	},
	components: {},
	data() {
		return {
			tr: null,
			active: false,
		}
	},
	methods: {
		stick_to(component) {
			createPopper(component, this.$el, {
				placement: 'top',
			});
		},
		get_popover(name) {
			return popovers[name];
		}
	},
	mounted() {
		popovers[this.name] = this;
	}
}
</script>

<style scoped>

.popover {
	z-index: 10;
}

</style>